import "./TeamSection.scss";

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Vikram R Singh",
      role: "Chief Executive Officer (CEO)",
      image: "/LandingPageImages/VikramRSingh.jpg",
    },
    {
      name: "Shashi Pal  ",
      role: "Chief Operating Officer (COO) ",
      image: "/LandingPageImages/ShashiPalSingla.jpg",
    },
    {
      name: "Nishant Mitra",
      role: "Chief Technology Officer (CTO)",
      image: "/LandingPageImages/NishantMitra.jpg",
    },
  ];

  return (
    <section className="team-section">
      <div className="team-container">
        <div className="team-title-content">
          <h2 className="team-title">Our Team</h2>
          <p className="team-description">
            We are a dedicated team of creators, engineers, and problem-solvers working toward
            a smarter and more trusted digital future. Collaboration drives everything we build.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-image-wrapper">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-image"
                />
              </div>
              <div className="team-member-content">
                <h3 className="team-member-name">{member.name}</h3>
                <p className="team-member-role">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;

